export const sortByName = (a, b) => a.name.localeCompare(b.name, "uk");

export const mapCategory = (cat) => ({
  id: cat.id,
  name: cat.name,
  isAppVisible: !!cat.isAppVisible,
  children: Array.isArray(cat.children) ? cat.children.map(mapCategory) : [],
});

export const sortCategoryTree = (list) => {
  if (!Array.isArray(list)) return [];
  return [...list]
    .sort(sortByName)
    .map((cat) => ({
      ...cat,
      children: sortCategoryTree(cat.children),
    }));
};

export const normalizeCategories = (list) =>
  sortCategoryTree((list || []).map(mapCategory));

export const updateCategoryVisibility = (list, id, nextValue) =>
  list.map((cat) => {
    if (`${cat.id}` === `${id}`) {
      return { ...cat, isAppVisible: nextValue };
    }
    if (cat.children && cat.children.length) {
      return {
        ...cat,
        children: updateCategoryVisibility(cat.children, id, nextValue),
      };
    }
    return cat;
  });

const getProductsList = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};

export const normalizeProduct = (product) => {
  const isAppVisible =
    product?.appvisible ?? product?.appVisible ?? product?.isAppVisible ?? false;
  return {
    ...product,
    jpTitle: product?.t || product?.name || "Без назви",
    jpImg: product?.img || null,
    jpIsAppVisible: !!isAppVisible,
  };
};

export const normalizeProductsResponse = (data) => {
  const list = getProductsList(data);
  return {
    results: list
      .map((product) => normalizeProduct(product))
      .sort((a, b) => a.jpTitle.localeCompare(b.jpTitle, "uk")),
  };
};

export const updateProductsVisibility = (prev, productId, nextValue) => {
  if (!prev || !Array.isArray(prev.results)) return prev;
  return {
    ...prev,
    results: prev.results.map((product) =>
      `${product.id}` === `${productId}`
        ? {
            ...product,
            appvisible: nextValue,
            appVisible: nextValue,
            isAppVisible: nextValue,
            jpIsAppVisible: nextValue,
          }
        : product,
    ),
  };
};
